import { doPost } from './common'

export const start = (breakId, stepId) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
  }

  return doPost(`/quiz/start`, payload)
}

/*

API expects
{
  "quizId": "string",
  "quizResult": {
    "resultId": "string",
    "quizQuestionAnswers": [
      {
        "questionId": "string",
        "answerId": "string"
      }
    ]
  }
}

*/

export const saveQuizResult = (quizId, resultId, questionAnswerSet) => {
  let payload = {
    quizId: quizId,
    quizResult: {
      resultId: resultId,
      quizQuestionAnswers: questionAnswerSet,
    },
  }

  return doPost(`/quiz/result`, payload)
}

export const complete = (breakId, stepId) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
  }

  return doPost(`/quiz/complete`, payload)
}

//deprecated - moved to service/break.js
// export const getPersonalityResultID = (quizId) => {
//     return doGet(`/quiz/result/${quizId}`);
// }
